import React from "react";
import { Switch, SwitchProps } from "react-native";

import { kColors } from "src/kColors";

export const PdSwitch = React.forwardRef<Switch, SwitchProps>((props, ref) => {
  return (
    <Switch
      ref={ref}
      trackColor={{ false: kColors.gray500, true: kColors.brandGreen }}
      // according to RNW Docs the prop exists and it's working: https://necolas.github.io/react-native-web/docs/switch/
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      activeThumbColor="white"
      thumbColor="white"
      {...props}
    />
  );
});
